import React from 'react';
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
// import { width } from '@mui/system';

// Define the styles
const styles = StyleSheet.create({
  container: {
    border: '1px solid black',
    padding: 10,
    width: '100%',
    height: '100%',
    flexDirection: 'column',
  },
  header: {
    textAlign: 'center',
    marginBottom: 10,
    marginTop: 10,
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subtitle: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 5,
  },
  divider: {
    marginVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: 'black',
  },
  tableContainer: {
    marginTop: 20,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: 'black',
    paddingVertical: 5,
  },
  tableRowBg: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: 'black',
  },
  tableCell: {
    fontSize: 10,
    flex: 1,
    padding: 5,
    textAlign: 'center',
  },
  tableCellHeader: {
    backgroundColor: 'black',
    color: 'white',
    fontWeight: 'bold',
  },
  totalRow: {
    fontSize: 10,
    backgroundColor: '#ccc',
    textAlign: 'right',
    padding: 5,
  },
  totalCell: {
    fontSize: 10,
    flex: 1,
    padding: 5,
    textAlign: 'right',
  },
  detailItem: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  detailLabel: {
    fontSize: 10,
  },
  detailValue: {
    fontSize: 10,
  },
  qrCodeContainer: {
    display: 'flex',
  },
  qrCode: {
    width: 100,
    height: 100,
  },
  sideBySideContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  sideBySideView: {
    flex: 1,
  },
});

const chunkArray = (array, chunkSize) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
};

// TableHeader Component
const TableHeader = () => (
  <View style={[styles.tableRow, styles.tableCellHeader]}>
    <Text style={[styles.tableCell]}>Class</Text>
    <Text style={[styles.tableCell, { flex: 2 }]} >Description</Text>
    {/* <Text style={[styles.tableCell]}></Text> */}
    <Text style={[styles.tableCell]}>Quantity</Text>
    <Text style={[styles.tableCell]}>Unit Price</Text>
    <Text style={[styles.tableCell]}>Disc</Text>
    <Text style={[styles.tableCell]}>Tax Rate</Text>
    <Text style={[styles.tableCell]}>Tax Amt</Text>
    <Text style={[styles.tableCell]}>Total Amt</Text>
  </View>
);

const DetailItem = ({ label, value, justify, totalPages }) => (
  <View style={[styles.detailItem, { justifyContent: justify }]}>
    <Text style={[styles.detailLabel, { textAlign: 'left' }]}>{label}</Text>
    <Text style={[styles.detailValue, { textAlign: justify === 'flex-end' ? 'right' : 'left' }]}>
      {totalPages ? `: ${value}/${totalPages}` : value ? `: ${value}` : ''}
    </Text>
  </View>
);

// Reusable Header Component
const InvoiceHeader = ({ data }) => (
  <View style={styles.header}>
    <Text style={styles.title}>{data.supplierInfo.name}</Text>
    <Text style={styles.subtitle}>
      {`${data.supplierInfo.address}, ${data.supplierInfo.state}, ${data.supplierInfo.country}`}
    </Text>
    <Text style={styles.subtitle}>{data.supplierInfo.phone}</Text>
  </View>
);

// Reusable Details Component
const InvoiceDetails = ({ data, pageNumber, totalPages }) => (
  <View style={styles.sideBySideContainer}>
    <View style={styles.sideBySideView}>
      <DetailItem label="Supplier TIN" value={data.supplierInfo.tin} justify="flex-start" />
      <DetailItem label="Supplier Registration Number" value={data.supplierInfo.bussinessValue} justify="flex-start" />
      <DetailItem label="Supplier SST Number" value={data.supplierInfo.sst} justify="flex-start" />
      <DetailItem label="Supplier MSIC Code" value={data.supplierInfo.msicNum} justify="flex-start" />
      <View style={{ flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
        <Text style={{ fontWeight: 'bold', fontSize: 10 }}>
          Supplier Business Description:{' '}
        </Text>
        <Text style={{ fontSize: 10, flexShrink: 1 }}>
          {data.supplierInfo.bussinessDesc}
        </Text>
      </View>
      <View style={styles.tableContainer} /><View style={styles.tableContainer} />
      <DetailItem label="Buyer TIN" value={data.buyerInfo.tin} justify="flex-start" />
      <DetailItem label="Buyer Name" value={data.buyerInfo.name} justify="flex-start" />
      <DetailItem label="Buyer Registration Number" value={data.buyerInfo.bussinessValue} justify="flex-start" />
      <DetailItem label="Buyer SST Number" value={data.buyerInfo.sst} justify="flex-start" />
      <DetailItem label="Buyer Phone Number" value={data.buyerInfo.phone} justify="flex-start" />
      <DetailItem label="Buyer Email" value={data.buyerInfo.email} justify="flex-start" />
    </View>
    <View style={styles.sideBySideView}>
      <Text style={{ ...styles.title, textAlign: 'right', marginBottom: 10 }}>E-Invoice</Text>
      <DetailItem label="e-invoice Type" value={`${data.invoiceInfo.typeCode} ${data.invoiceInfo.type}`} justify="flex-end" />
      <DetailItem label="e-invoice Version" value={data.invoiceInfo.version} justify="flex-end" />
      <DetailItem label="e-invoice Code" value={data.invoiceInfo.number} justify="flex-end" />
      <DetailItem label="Original Invoice Ref. No." value={data.invoiceInfo.oriRefNumber} justify="flex-end" />
      <DetailItem label="Invoice Date" value={data.invoiceInfo.date} justify="flex-end" />
      <DetailItem label="Page" value={pageNumber} totalPages={totalPages} justify="flex-end" />
    </View>
  </View>
);

const TableRows = ({ data }) => (
  <>
    {data.map((row, i) => (
      <View key={i} style={styles.tableRow} wrap={false}>
        <Text style={styles.tableCell}>{row.classId || '-'}</Text>
        <Text style={[styles.tableCell, { flex: 2 }]} >{row.lineDesc || '-'}</Text>
        <Text style={styles.tableCell}>{row.qty || 0}</Text>
        <Text style={styles.tableCell}>{parseFloat(row.unitPrice).toFixed(2) || 0.0}</Text>
        <Text style={styles.tableCell}>{parseFloat(row.discAmt).toFixed(2) || 0.0}</Text>
        <Text style={styles.tableCell}>{parseFloat(row.taxRate).toFixed(0) || 0}</Text>
        <Text style={styles.tableCell}>{parseFloat(row.taxAmt).toFixed(2) || 0.0}</Text>
        <Text style={styles.tableCell}>{parseFloat(row.total_LineAmt).toFixed(2) || 0}</Text>
      </View>
    ))}
  </>
);

// Main PDF Document
export const ReportPDF = ({ data, qrDataUrl }) => {
  const itemsPerPage = 7; // Number of rows per page
  const chunkedData = chunkArray(data.productInfo, itemsPerPage); // Split data into chunks

  return (
    <Document>
      {chunkedData.map((chunk, pageIndex) => (
        <Page style={styles.container} key={pageIndex} render={({ pageNumber, totalPages }) => (
          <>
            {/* Header */}
            <InvoiceHeader data={data} />

            <View style={styles.divider} />

            {/* Details */}
            <InvoiceDetails data={data} pageNumber={pageNumber} totalPages={totalPages} />

            {/* Table Header */}
            <View style={styles.tableContainer}>
              <TableHeader />
            </View>

            {/* Table Rows */}
            <TableRows data={chunk} />

            {/* Conditionally Render Totals and Footer on the Last Page */}
            {pageIndex === chunkedData.length - 1 && (
              <>
                {/* Total Rows */}
                <View style={styles.tableRowBg}>
                  <Text style={[styles.totalRow, { flex: 7 }]}>Total Exclude Tax</Text>
                  <Text style={styles.totalCell}>{parseFloat(data.invoiceInfo.total_ExcludeTax).toFixed(2)}</Text>
                </View>
                <View style={styles.tableRowBg}>
                  <Text style={[styles.totalRow, { flex: 7 }]}>Total Tax Amount</Text>
                  <Text style={styles.totalCell}>{parseFloat(data.invoiceInfo.total_TaxAmt).toFixed(2)}</Text>
                </View>
                <View style={styles.tableRowBg}>
                  <Text style={[styles.totalRow, { flex: 7 }]}>Total including tax</Text>
                  <Text style={styles.totalCell}>{parseFloat(data.invoiceInfo.total_IncludeTax).toFixed(2)}</Text>
                </View>
                <View style={styles.tableRowBg}>
                  <Text style={[styles.totalRow, { flex: 7 }]}>Total payable amount</Text>
                  <Text style={styles.totalCell}>{parseFloat(data.invoiceInfo.total_PayableAmt).toFixed(2)}</Text>
                </View>

                {/* Footer */}
                <View style={styles.sideBySideContainer}>
                  <View style={{ ...styles.sideBySideView, marginTop: '10px', fontSize: '8px' }} >
                    <DetailItem label="Digital Signature" value={data.invoiceInfo.signature || ""} justify="flex-start" />
                    <DetailItem label="Date and Time Validation" value={data.invoiceInfo.validatedate || ""} justify="flex-start" />
                    <DetailItem label="This document is a visual presentation of the e-invoice" value="" justify="flex-start" />
                  </View>
                  {data.invoiceInfo.docuuid && (
                    <View style={{ display: "flex", justifyContent: 'flex-end' }} >
                      <Image style={{ ...styles.qrCode, padding: "10px" }} src={qrDataUrl} />
                    </View>
                  )}
                </View>
              </>
            )}
          </>
        )}>
        </Page>
      ))}
    </Document>
  );
};
